import { handleActions, createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'CREATE_BRAND',
    'FETCH_BRAND_LIST',
    'FETCH_BRAND_LIST_SUCCESS',
    'FETCH_BRAND',
    'FETCH_BRAND_SUCCESS',
    'UPDATE_BRAND',
    'UPDATE_BRAND_BRANDING',
    'UPDATE_BRAND_OPTIONS',
    'DELETE_BRAND',
    'DELETE_BRAND_SUCCESS'
], 'BRAND');

// Action Creators
export const createBrandForm = createFormAction(actions.CREATE_BRAND);
export const updateBrandForm = createFormAction(actions.UPDATE_BRAND);
export const updateBrandBrandingForm = createFormAction(actions.UPDATE_BRAND_BRANDING);
export const updateBrandOptionsForm = createFormAction(actions.UPDATE_BRAND_OPTIONS);
export const fetchList = createAction(actions.FETCH_BRAND_LIST);
export const fetchListSuccess = createAction(actions.FETCH_BRAND_LIST_SUCCESS);
export const fetchBrand = createAction(actions.FETCH_BRAND);
export const fetchBrandSuccess = createAction(actions.FETCH_BRAND_SUCCESS);
export const deleteBrand = createAction(actions.DELETE_BRAND);
export const deleteBrandSuccess = createAction(actions.DELETE_BRAND_SUCCESS);

// Reducers
const initialState = {
    list: [],
    listFetched: false,
    brand: null
};

export default handleActions({
    [actions.FETCH_BRAND_LIST_SUCCESS]: (state, action) => {
        const updatedData = {
            list: { $set: action.payload },
            listFetched: { $set: true }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_BRAND_SUCCESS]: (state, action) => {
        const updatedData = {
            brand: { $set: action.payload }
        };
        return update(state, updatedData);
    },
    [actions.DELETE_BRAND_SUCCESS]: (state) => {
        const updatedData = {
            brand: { $set: null }
        };
        return update(state, updatedData);
    }
}, initialState);



// WEBPACK FOOTER //
// ./src/services/brands/duck.js